import { sentryEnvironment } from '@ebeihilfe/assets/sentry';
import { Environment } from '@ebeihilfe/core';

export const environment: Environment = {
  production: true,
  pinConfiguration: { storage: 'persistent' },
  authentication: {
    grants: ['password'],
  },
  sentry: sentryEnvironment,
  onlyWeb: true,
};
